import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ContactService } from '../Services/contactUs.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../Module/shared.module';
import { ToasterComponent } from "../../toaster/toaster.component";

@Component({
  selector: 'app-contact-us-shared',
  imports: [TranslateModule, ReactiveFormsModule, CommonModule, SharedModule, ToasterComponent],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.css',
})
export class ContactUsComponent {
  contactForm!: FormGroup;
  @Input() alignment: string = 'text-end';
  @Input() buttonAlign: any = 'mx-0'
  showToast = false;
  toastMessage = '';
  toastType: 'success' | 'error' = 'success';


  private fb = inject(FormBuilder);
  private contactService = inject(ContactService);
  private translate = inject(TranslateService)

  internationalPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      // لازم يبدأ بـ + ورقم دولة وبعده رقم
      const regex = /^\+\d{1,4}\d{10,14}$/;

      return regex.test(control.value)
        ? null
        : { invalidPhoneCode: true };
    };
  }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(3)]],
      lastName: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [
        Validators.required,
        Validators.email,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
      ]],
      mobile: ['', [
        Validators.required,
        this.internationalPhoneValidator()
      ]],
      content: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  onSubmit(): void {
    this.contactForm.markAllAsTouched();
    if (this.contactForm.valid) {
      const formData = this.contactForm.value;
      this.contactService.createMessage(formData).subscribe({
        next: () => {
          this.toastType = 'success';
          this.toastMessage = this.translate.instant('CONTACT.SUCCESS');
          this.showToast = true;
          this.contactForm.reset();
          setTimeout(() => this.showToast = false, 3000);
        },
        error: () => {
          this.toastType = 'error';
          this.toastMessage = this.translate.instant('CONTACT.ERROR');
          this.showToast = true;
          setTimeout(() => this.showToast = false, 3000);
        }
      });
    }
  }

  // Optional: Getter for easy access in template
  get f() {
    return this.contactForm.controls;
  }
}

